<template>
  <v-dialog
      v-model="dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="dialog=false">
          <v-icon large color="primary">close</v-icon>
        </v-btn>
      </v-col>
      <v-container v-if="dialog">
        <v-row justify="space-around">
          <v-col cols="12" md="5">
            <v-text-field
                outlined
                v-model="option.name"
                :label="$t('common:name')"
            />
            <v-textarea
                outlined
                v-model="option.description"
                :label="$t('common:description')"
                auto-grow
            />
            <v-select
                outlined
                :items="optionTypes"
                item-text="name"
                item-value="id"
                v-model="option.type"
                :label="$t('common:type')"
            />
            <v-text-field
                outlined
                v-model="option.defaultValue"
                :label="$t('settings/settings:option.default-value')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card
                elevation="0"
                flat
                tile
                class="pl-3 pt-3 pb-md-3"
            >
              <TwoButtonDialog
                  ref="saveButton"
                  :btn-text="$t('buttons:save')"
                  color="primary"
                  :hideOverlay="true"
                  :dialog-title="$t('dialog:save-btn-title', {name : $t('settings/settings:option.option') })"
                  :dialog-text="$t('dialog:save-btn-dialog', {name : $t('settings/settings:option.option') })"
                  :button1-text="$t('buttons:save')"
                  :button2-text="$t('buttons:cancel')"
                  @clickedButton1="updateForm()"
                  @clickedButton2="$refs.saveButton.showDialog = false"
              />
              <DirtyConfirmButtonDialog
                  ref="dirtyDialog"
                  :btn-text="$t('buttons:back')"
                  color="grey"
                  :hideOverlay="true"
                  :dialog-title="$t('dialog:save-btn-title')"
                  :dialog-text="$t('dialog:save-btn-dialog')"
                  :button1-text="$t('dialog:dirty-save-btn-1-text')"
                  :button2-text="$t('dialog:dirty-save-btn-2-text')"
                  @clickedButton="dialog=false"
              />
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

import DirtyConfirmButtonDialog from '@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';
import OptionService from '@/modules/settings/services/option-service';
import InfoService from "@/modules/core/services/info-service";
import Utils from '@/modules/core/services/utils';

export default {
  name: "MetaForm",
  components: {
    DirtyConfirmButtonDialog,
    TwoButtonDialog
  },
  data() {
    return {
      optionTypes: [],
      dialog: false,
      edit: false,
      option: {}
    }
  },
  methods: {
    updateForm() {
      this.dialog = false;
      OptionService.saveOption(
          this.option,
          () => {
            if (!this.edit) {
              Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('settings/settings:option.option')}));
            } else {
              Utils.showSuccessSnackbar(this.$t('snackbar:edit-success', {name: this.$t('settings/settings:option.option')}));
            }

            this.$emit('updateTable');
          },
          () => {
            if (!this.edit) {
              Utils.showFailureSnackbar(this.$t('snackbar:add-failure', {name: this.$t('settings/settings:option.option')}));
            } else {
              Utils.showFailureSnackbar(this.$t('snackbar:edit-failure', {name: this.$t('settings/settings:option.option')}));
            }
          }
      )
    },
    initialization(item) {
      this.option = {};
      this.edit = false;

      if (typeof item !== 'undefined' && typeof item.id !== 'undefined') {
        this.option = item;
        this.edit = true;
      }

      this.dialog = true;
    }
  },
  created() {
    InfoService.readEnum("option/type",
        (resp) => {
          resp.data.forEach(
            (type) => {
              this.optionTypes.push({name: type, id: type})
            }
          )
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('settings/settings:option.option-type')}))
        }
    )
  }
}

</script>
